module.exports = __webpack_public_path__ + "media/images/logo-mini-reverse-0696f561cbb310dcf86755a8ea612a4e.svg";